import type {Model} from '@github-ui/marketplace-common'

export function supportsStreaming(model: Model) {
  return model.name !== 'o1-mini' && model.name !== 'o1-preview'
}

export function supportsStructuredOutput(model: Model) {
  // currently the Cohere models have a bug where they expect a different API format for structured output
  if (model.name.toLowerCase().includes('cohere')) {
    return false
  }

  // currently o1-class models don't support structured outputs at all
  if (model.name.toLowerCase().includes('o1')) {
    return false
  }

  return true
}
